import React, { useState } from 'react'
import PostCard from '../../components/PostCard/PostCard';
import { FirebaseHelper } from '../../firebase-helper';
import './PostsPage.scss'

function PostsPage() {
    const [posts, setPosts] = useState([]);

    const firebaseHelperPosts = new FirebaseHelper("posts");
    const postsRef = firebaseHelperPosts.usersCollectionRef;
    useState(()=>{
        const getPosts = async () => {
            var posts = await FirebaseHelper.getAllDocs(postsRef)
            posts.sort(function(a, b) {
                var c = Date.parse(a.publishDate);
                var d = Date.parse(b.publishDate);
                return d-c;
            });
            setPosts(posts)
          }
          getPosts();
          
    },[]);

    return (
        <div className='posts-page'>
            <div className='posts-section'>
                {
                    posts&& posts.map((post)=>{
                        return(
                            <PostCard key={post.id} post={post}/>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default PostsPage